export const BITMATRIX_RPC_URL = 'https://rpc.basebitmatrix.com/';
export const BLOCKSTREAM_EXPOLORER = 'https://blockstream.info/liquidtestnet/tx/';
export const MEMPOOL_EXPLORER = 'https://liquid.network/testnet/tx/';
